export default "__VITE_ASSET__46456ba7__"